import { render } from "./ArticleCell.vue?vue&type=template&id=3fcf2c45&scoped=true&bindings={\"article\":\"props\",\"index\":\"props\",\"$_onDetailClicked\":\"options\",\"localDateText\":\"options\"}"
import script from "./ArticleCell.vue?vue&type=script&lang=js"
export * from "./ArticleCell.vue?vue&type=script&lang=js"

import "./ArticleCell.vue?vue&type=style&index=0&id=3fcf2c45&scoped=true&lang=less"
script.render = render
script.__scopeId = "data-v-3fcf2c45"

export default script